import React, { useContext, useEffect } from 'react'
import NavBar from './NavBar'
import SideBar from './sideBar'
import classNames from 'classnames'
import NavbarMobile from './NavBarMobile'
import DetailsUserContainer from 'containers/homeContainers/detailsUserContainer'
import { ProfileRequest } from 'requests/user'
import UserContext from 'contexts/UserContext'
import localforage from 'localforage'

const Layout = (props: any) => {
  const { user, setUser } = useContext(UserContext)
  useEffect(() => {
    async function fetchData() {
      const id = user?.user?._id
      const token = user?.token?.accessToken
      try {
        const response = await ProfileRequest(id, token)
        if (response?.success === true) {
          if (user) {
            setUser({ token: user?.token, success: true, user: response.user })
            localforage.setItem('auth', JSON.stringify({ token: user?.token, success: true, user: response.user }))
          }
        }
      } catch (error) {
        console.error(error)
      }
    }
    // if (user?.user?.status === 'pending') {
      fetchData()
    // }
  }, [user?.user._id, user?.token?.accessToken,user?.user.destinationDefaultCountry])
  return (
    <div>
      <div className={classNames(props.show && 'hidden')}>
        <NavbarMobile />
      </div>
      <main className="flex">
        <div className={classNames(props.show ? 'hidden ' : 'w-[310px] xl:w-[250px]  lg:w-auto ')}>
          <SideBar />
        </div>
        <div 
        className={classNames(props.show ? 'w-full ':
          'flex-1 min-h-screen overflow-y-auto w-full px-[40px] pt-[40px] sm:px-[24px] lg:py-0 ',
          (!props.showSideBarRight && !props.show ) && 'z-50 lg:z-0' 
        )}>
          {!props.show && <NavBar />}
          {props.children}
        </div>

       {!props.DetailsUserContainer &&
        <div 
          className={classNames(props.showSideBarRight ? 'w-[380px] xl:w-[250px] lg:w-auto  ' : !props.show && 'w-[380px] xl:w-[250px] overflow-hidden h-screen right-0  pointer-events-none fixed', ' xl:hidden overflow-hidden')}>
          {(!props.showSideBarRight && !props.show) && <div className='w-[480px] xl:w-[250px] h-screen z-50 fixed  backdrop-blur-[3px]  bg-[rgba(87,84,229,0.6)] will-change-[backdrop-filter] [@supports(-webkit-backdrop-filter:blur(5px))]:[-webkit-backdrop-filter:blur(5px)]'/>}

        <DetailsUserContainer/>
        </div>}
      </main>
    </div>
  )
}

export default Layout

